var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("table", { attrs: { border: "1", cellspacing: "0" } }, [
        _c("colgroup", [
          _c("col", { staticStyle: { width: "9%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "12%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "16%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "14%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "13%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "18%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "18%" } }),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "table-title", attrs: { colspan: "7" } }, [
            _c("b", [_vm._v("第三方信息共享清单")]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_c("b", [_vm._v("功能类型")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("第三方名称")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("使用目的")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("使用场景")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("共享方式")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("个人信息类型")])]),
          _vm._v(" "),
          _c("td", [_c("b", [_vm._v("第三方隐私政策链接")])]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { attrs: { rowspan: "2" } }, [_vm._v("支付")]),
          _vm._v(" "),
          _c("td", [_vm._v("微信支付")]),
          _vm._v(" "),
          _c("td", [_vm._v("帮助用户在应用内使用微信支付完成会员购买")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户需要支付费用时")]),
          _vm._v(" "),
          _c("td", [_vm._v("微信支付SDK本地采集")]),
          _vm._v(" "),
          _c("td", [
            _c("b", [
              _c("i", [
                _vm._v(
                  "设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "link" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2"
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("支付宝")]),
          _vm._v(" "),
          _c("td", [_vm._v("帮助用户在应用内使用支付宝支付完成会员购买")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户需要支付费用时")]),
          _vm._v(" "),
          _c("td", [_vm._v("支付宝SDK本地采集")]),
          _vm._v(" "),
          _c("td", [
            _c("b", [
              _c("i", [
                _vm._v(
                  "设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息、传感器、设备序列号、ip地址、运营商信息"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "link" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000174",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000174"
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { attrs: { rowspan: "2" } }, [_vm._v("工具")]),
          _vm._v(" "),
          _c("td", [_vm._v("Cocos2D-X SDK")]),
          _vm._v(" "),
          _c("td", [_vm._v("帮助用户使用应用时确认设备稳定")]),
          _vm._v(" "),
          _c("td", [_vm._v("仅在启动APP、初始化时进行收集")]),
          _vm._v(" "),
          _c("td", [_vm._v("SDK本地采集")]),
          _vm._v(" "),
          _c("td", [_c("b", [_c("i", [_vm._v("设备传感器")])])]),
          _vm._v(" "),
          _c("td", { staticClass: "link" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _vm._v(
                  "https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html"
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Chromium SDK")]),
          _vm._v(" "),
          _c("td", [_vm._v("调用浏览器功能，展示软件的常见问答信息")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户打开帮助页面等调用浏览器时")]),
          _vm._v(" "),
          _c("td", [_vm._v("SDK本地采集")]),
          _vm._v(" "),
          _c("td", [
            _c("b", [
              _c("i", [
                _vm._v(
                  "监听剪切板、获取当前已连接上的wifi的信息、获取SSID信息、获取BSSID信息"
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "link" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.chromium.org/Home/chromium-privacy/",
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [_vm._v("https://www.chromium.org/Home/chromium-privacy/")]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }